// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XY3W","colMin":"styles_colMin__3Wxtq"};